import { render, staticRenderFns } from "./Bus.vue?vue&type=template&id=4a0ff84b"
import script from "./Bus.vue?vue&type=script&lang=js"
export * from "./Bus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports